import React from 'react';
import { Tooltip } from '@fluentui/react-components';
import moment from 'moment';

interface DayProps {
    day: Date;
    visitCount: number;
    isToday?: boolean;
}

const intensityLevel = (count: number): 0 | 1 | 2 | 3 | 4 => {
    if (count <= 0) return 0;
    if (count === 1) return 1;
    if (count <= 3) return 2;
    if (count <= 6) return 3;
    return 4;
};

const PractitionerProtocolActivityDayBase = ({ day, visitCount, isToday }: DayProps) => {
    const level = intensityLevel(visitCount);
    const formatted = moment(day).format('DD/MM/YYYY');
    const unit = visitCount === 1 ? 'visita' : 'visitas';
    const label = visitCount > 0
        ? `${formatted} — ${visitCount} ${unit}`
        : `${formatted} — sin visitas`;

    const className = [
        'activity-cell',
        `activity-cell-l${level}`,
        isToday ? 'activity-cell-today' : '',
        visitCount > 0 ? 'activity-cell-clickable' : ''
    ].filter(Boolean).join(' ');

    return (
        <Tooltip content={label} relationship="label" withArrow>
            <span className={className} aria-label={label}>
                {visitCount > 0 ? visitCount : day.getDate()}
            </span>
        </Tooltip>
    );
};

export const PractitionerProtocolActivityDay = React.memo(PractitionerProtocolActivityDayBase);
